import React from "react";

//Loading screen
function Loading() {
  return (
    <main id="loader">
      <div id="loader__wrapper">
        <div>g</div>
        <div>n</div>
        <div>i</div>
        <div>d</div>
        <div>a</div>
        <div>o</div>
        <div>L</div>
      </div>
    </main>
  );
}

export default Loading;
